import { Route } from "react-router-dom";

import CustomerQuotationScreen from "./pages/CustomerQuotationScreen";

export const CustomerRoutes = () => {
  return (
    <>
      <Route path="/dashboard" element={<CustomerQuotationScreen />} />
    </>
  );
};
